module.exports = __webpack_public_path__ + "img/mhtit1.3f4d1056.png";